import Prices from "../../Prices";
import Chosen from "../../../forms/Inputs/Select/Chosen";
import {gsap} from "gsap";
import PricesVehicle from "../Vehicle/Vehicle";
import TableSearch from "../../../../templates/src/Components/TableSearch/TableSearch";
import moment from "moment";

const PricesList = {

    decimalsParam: 2,

    init() {
        this.el = $('[page="prices"].PricesList div.categorySection');
        if (!this.el.length) return;

        this.priceSortableTable = this.el.find('.grid.table');
        this.resetButton = this.el.find("button.reset");
        this.addButton = this.el.find("button.add");

        PricesVehicle.init(this.el);
        TableSearch.init();

        this.bind(this.el);
    },

    bind(el) {
        setTimeout(() => {
            this.bindSortableTable();
        }, 100);

        this.priceSortableTable.find(".cell.vehicle").on("click", function () {
            if (!Prices.editable) return;

            let row = $(this).parents().closest(".row");

            if (!row.hasClass("new")) {
                row.find("input").first().focus();
            }
        });

        this.resetButton.on("click", (el) => {
            let section = $(el.currentTarget).parents().closest(".categorySection");
            this.resetSection(section);
        });

        this.addButton.on("click", (evt) => {
            const el = $(evt.currentTarget);
            const section = el.closest(".categorySection");

            if(el.is('.emptyVehicles')){
                this.showEmptyWarning(section);
                return;
            }

            if (section.find(".new.empty").length === 0) {
                PricesList.setSectionChanged(section);
                PricesVehicle.add(section);
            }
        });
    },

    showEmptyWarning(section){
        gsap.timeline()
            .to(section.find(".emptyWarning"), {opacity:1, duration:0.3},0)
            .to(section.find(".emptyWarning"), {opacity:0, duration:0.3},1.5)
    },

    bindSortableTable() {
        this.priceSortableTable.each(function () {
            let table = $(this);
            let headerCells = Prices.isPackageList ? table.find('.header .rowGroup .cell').not(".sortIgnore") : table.find('.header .cell').not(".sortIgnore");

            headerCells.on("click", function () {
                let $clickedCell = $(this);
                let columnIndex = $clickedCell.index();
                let columnGroupIndex = Prices.isPackageList ? $clickedCell.closest('.cellGroup').index() : null;
                let isAscending = !$clickedCell.hasClass('sorted-asc');

                // Remove sorting classes from all header cells in this table
                headerCells.removeClass('sorted-asc sorted-desc');

                // Toggle sorting class on the clicked header cell
                $clickedCell.toggleClass('sorted-asc', isAscending);
                $clickedCell.toggleClass('sorted-desc', !isAscending);

                // Sort rows based on the content of the clicked column
                let rows = table.find('.item').get();

                rows.sort(function (rowA, rowB) {
                    let cellA = PricesList.getCellValue(rowA, columnIndex, columnGroupIndex);
                    let cellB = PricesList.getCellValue(rowB, columnIndex, columnGroupIndex);

                    // Check if both cells contain numeric values
                    if (!isNaN(cellA) && !isNaN(cellB)) {
                        return isAscending ? parseFloat(cellA) - parseFloat(cellB) : parseFloat(cellB) - parseFloat(cellA);
                    } else {
                        // Compare strings
                        return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
                    }
                });

                // Reorder rows in the table
                $.each(rows, function (index, row) {
                    table.append(row);
                });
            });
        });
    },

    prepareData() {
        setTimeout(() => {
            let data = {
                new: {},
                update: {}
            };

            const isPackagePriceList = Prices.getPriceListType() === 'packages';
            let changes = $('input.changed, select.changed');

            if (changes.length === 0) {
                $("div.categorySection").removeClass("changed");
            }

            changes.each(function () {
                let itemRow = $(this).parents().closest(".row.item");
                let identification = itemRow.data();
                let priceRecordID = identification.id;
                let pricePriceListID = identification.pricelist_id;
                let priceVehicleID = identification.vehicle_id;

                let inputName = $(this).attr("name");

                if (isPackagePriceList) {
                    const packageLevel = $(this).closest(".cellGroup").attr("type");
                    const packageRecordID = $(this).closest(".cell.asInput").attr("item");

                    if (!packageLevel) {
                        return;
                    }

                    if (itemRow.hasClass("new") && itemRow.attr("id")) {
                        let newRecordTemporaryID = itemRow.attr("id");

                        if (!data.new[newRecordTemporaryID]) {
                            data.new[newRecordTemporaryID] = {
                                vehicle_id: priceVehicleID,
                                pricelist_id: pricePriceListID,
                                packages: {}
                            };
                        }

                        if (!data.new[newRecordTemporaryID].packages[packageLevel]) {
                            data.new[newRecordTemporaryID].packages[packageLevel] = {};
                        }

                        data.new[newRecordTemporaryID].packages[packageLevel][inputName] = $(this).val();
                    } else {
                        if (!data.update[priceVehicleID]) {
                            data.update[priceVehicleID] = {};
                        }

                        if (!data.update[priceVehicleID][packageRecordID]) {
                            data.update[priceVehicleID][packageRecordID] = {};
                        }

                        data.update[priceVehicleID][packageRecordID][inputName] = $(this).val();
                    }
                } else {
                    if (itemRow.hasClass("new") && itemRow.attr("id")) {
                        let newRecordTemporaryID = itemRow.attr("id");

                        if (!data.new[newRecordTemporaryID]) {
                            data.new[newRecordTemporaryID] = {
                                //vehicle_id: priceVehicleID,
                                pricelist_id: pricePriceListID,
                            };
                        }

                        data.new[newRecordTemporaryID][inputName] = $(this).val();
                    } else {
                        if (!data.update[priceRecordID]) {
                            data.update[priceRecordID] = {};
                        }

                        data.update[priceRecordID][inputName] = $(this).val();
                    }
                }
            });

            let json = !this.isEmpty(data.new) || !this.isEmpty(data.update) ? JSON.stringify(data) : "";

            Prices.setData(json);
        }, 100);
    },

    isEmpty(obj) {
        return Object.entries(obj).length === 0;
    },

    getCellValue(row, columnIndex, columnGroupIndex) {
        let element = $(row).find('.cellGroup').length !== 0 ? $(row).find('.cellGroup').eq(columnGroupIndex-1).find('.cell').eq(columnIndex) : $(row).find('.cell').eq(columnIndex);
        let value;

        if (element.find("input").length) {
            value = element.find("input").val();
        } else {
            value = element.text();
        }

        value = value.trim();
        value = value.replace(/\s/g, '');
        value = value.replace(/,/g, '.');

        return value;
    },

    setActiveList(categoryID) {
        let offset = $('[component="Header"]').outerHeight() + $('[section="tabs"]').outerHeight() + 16;
        let y = $('.categorySection[category="' + categoryID + '"]').offset().top;
        gsap.to('html, body', {scrollTo: {y: y, offsetY: offset}})
    },

    setSectionChanged(section) {
        section.addClass("changed");
    },

    resetSection(section) {
        let changes = $(section).find(".changed");
        let changedInputs = $(section).find("input.changed");

        changedInputs.each(function (index, el) {
            let defaultValue = $(el).data("value");

            $(el).trigger("change").val(defaultValue);
        });

        changes.removeClass("changed");
        $(section).removeClass("changed");
        PricesVehicle.removeNewRows(section);
        PricesVehicle.inactiveAddButton(section);
        PricesVehicle.checkIfSectionsEmpty(section);
        PricesList.prepareData();
    },

    generateRandomChars(length) {
        let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (var i = 0; i < length; i++) {
            let randomIndex = Math.floor(Math.random() * chars.length);
            result += chars[randomIndex];
        }

        return result;
    },
}

export default PricesList;